import * as Yup from 'yup';

export function isYupStringSchema(schema: Yup.Schema<unknown>) {
  return schema.describe().type === 'string';
}

export function isYupNumberSchema(schema: Yup.Schema<unknown>) {
  return schema.describe().type === 'number';
}

export function isYupBooleanSchema(schema: Yup.Schema<unknown>) {
  return schema.describe().type === 'boolean';
}

export function isYupObjectSchema(schema: Yup.Schema<unknown>) {
  return schema.describe().type === 'object';
}

export function isYupArraySchema(schema: Yup.Schema<unknown>) {
  return schema.describe().type === 'array';
}
